import { getDefaultPathIndexes } from '@exodus/asset-lib';
import assert from 'minimalistic-assert';
import KeyIdentifier from '@exodus/key-identifier';
const MODULE_ID = 'hardwareMessageSigner';
class HardwareMessageSigner {
    #assetsModule;
    #hardwareWallets;
    #assetSources;
    constructor({ assetsModule, hardwareWallets, assetSources }) {
        this.#assetsModule = assetsModule;
        this.#hardwareWallets = hardwareWallets;
        this.#assetSources = assetSources;
    }
    #getKeyId = async (opts) => {
        const { baseAssetName, message, walletAccount, purpose } = opts;
        assert(typeof baseAssetName === 'string', 'baseAssetName is required');
        assert(walletAccount && typeof walletAccount === 'object', 'walletAccount is required');
        assert(message && typeof message === 'object', 'message is required');
        const baseAsset = this.#assetsModule.getAsset(opts.baseAssetName);
        const compatibilityMode = walletAccount.compatibilityMode;
        const purposes = await this.#assetSources.getSupportedPurposes({
            assetName: baseAssetName,
            walletAccount: walletAccount.toString(),
        });
        assert(typeof purposes[0] === 'number', `no purposes returned by getSupportedPurposes`);
        const defaultPurpose = purposes[0];
        const defaultPathIndexes = getDefaultPathIndexes({
            asset: baseAsset,
            walletAccount,
            compatibilityMode,
        });
        const { chainIndex, addressIndex } = defaultPathIndexes;
        const keyId = baseAsset.api.getKeyIdentifier({
            purpose: purpose ?? defaultPurpose,
            accountIndex: walletAccount.index,
            addressIndex,
            chainIndex,
            compatibilityMode,
        });
        return new KeyIdentifier(keyId);
    };
    signMessage = async (opts) => {
        assert(this.#hardwareWallets, `hardwareWallets module not found`);
        const { baseAssetName, message, walletAccount } = opts;
        const baseAsset = this.#assetsModule.getAsset(baseAssetName);
        assert(baseAsset, `baseAsset not found`);
        assert(baseAsset.api.signMessage, `message signing not supported by asset ${baseAssetName}`);
        const keyId = await this.#getKeyId(opts);
        const device = await this.#hardwareWallets.requireDeviceFor(walletAccount);
        return device.signMessage({
            assetName: baseAssetName,
            derivationPath: keyId.derivationPath,
            message,
        });
    };
}
const createHardwareMessageSigner = (opts) => new HardwareMessageSigner(opts);
const hardwareMessageSignerDefinition = {
    id: MODULE_ID,
    type: 'module',
    factory: createHardwareMessageSigner,
    dependencies: ['assetsModule', 'assetSources', 'hardwareWallets?'],
};
export default hardwareMessageSignerDefinition;
